module.exports = __webpack_public_path__ + "static/media/mega645.1ccb1494.png";